export function MeetingEventObserver() {
  return null;
}

export default MeetingEventObserver;
